import { Component,  inject,  OnInit } from "@angular/core";
import { WebhookCommonComponent } from "../common.components";


@Component({
    selector: 'webhook-form-button',
    templateUrl: './webhook-form-button.component.html',
    styleUrl: './webhook-form-button.component.scss',
    standalone: false
})

export class WebhookFormButtonComponent extends WebhookCommonComponent implements OnInit {
   
    

}